import { render } from "./AfterSalesRefunds.vue?vue&type=template&id=fbe7c1da&ts=true"
import script from "./AfterSalesRefunds.vue?vue&type=script&lang=ts"
export * from "./AfterSalesRefunds.vue?vue&type=script&lang=ts"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__